import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/participants.action'
import participantsList from 'api/administration/participants/ListInactiveParticipants'

async function getList(page: number, searchText: string, sort: any[]) {
  return await participantsList(page, searchText, sort)
}

function* participantsListEffectSaga(action: any) {
  try {
    const { page, searchText, sort } = action.payload
    const { data, total, perPage } = yield call(getList, page, searchText, sort)
    yield put(fromActions.Actions.participantsInactiveProfilesListSuccess(data, total, perPage, sort))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* inactiveParticipantsListWatcherSaga() {
  yield takeLatest(fromActions.PARTICIPANTS_INACTIVE_PROFILES_LIST, participantsListEffectSaga)
}
